import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
export const MAX_CARD_WIDTH = 384;
export const PRODUCT_CARD_NEW_PURPLE = '#9B00FE';
export const PRODUCT_CARD_NEW_GOLD = '#8D6A00';
export const PRODUCT_CARD_NEW_GREY = '#4F4F4F';
const useStyles = makeStyles()((theme, _params, classes) => ({
    productCard: {
        width: '100%',
        maxWidth: `${MAX_CARD_WIDTH}px`,
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        boxShadow: theme.isFlyingFlowers
            ? '0px 2px 2px rgba(60, 60, 59, 0.48), 0px 4px 8px rgba(60, 60, 59, 0.16)'
            : '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        '& .react-multi-carousel-dot-list': {
            position: 'initial',
        },
        [theme.breakpoints.up('md')]: {
            margin: 0,
        },
        overflow: 'visible',
    },
    cardClickable: {
        '&:hover': {
            backgroundColor: colors.grey.grey1,
            cursor: 'pointer',
        },
        [`&.${classes.productCardBorder}:active`]: {
            boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.12), 0px 8px 20px rgba(0, 0, 0, 0.04)',
        },
        [`&.${classes.productCardBorder}:focus`]: {
            boxShadow: '0px 0px 8px #008be9, 0px 4px 8px rgba(0, 0, 0, 0.32)',
        },
    },
    productCardBorder: {},
    priceContainer: {
        marginBottom: spacing.medium,
    },
    deliveryPassPriceContainer: {
        marginBottom: spacing.small,
    },
    price: Object.assign(Object.assign({}, theme.typography.medium_bold), { paddingRight: spacing.xs, color: theme.isFlyingFlowers ? colors.black[700] : undefined, [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.xl_bold) }),
    deliveryPassPrice: Object.assign(Object.assign({}, theme.typography.small_bold), { paddingRight: spacing.xs }),
    promoText: Object.assign(Object.assign({}, theme.typography.medium_bold), { color: colors.secondary.lavender }),
    deliveryPassPromoText: Object.assign(Object.assign({}, theme.typography.small_regular), { color: colors.grey.grey6, marginBottom: spacing.medium }),
    productName: Object.assign(Object.assign({ display: 'block' }, theme.typography.small_regular), { marginBottom: _params.isNewDesign ? 0 : spacing.small, marginTop: 0, color: theme.isFlyingFlowers ? colors.black[700] : undefined, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, (_params.isNewDesign ? theme.typography.small_regular : theme.typography.medium_regular)), { display: 'flex', flexGrow: 1 }) }),
    deliveryPassProductName: Object.assign(Object.assign({ display: 'block' }, theme.typography.medium_bold), theme.typographySpacing.medium_bold_lg),
    textContent: {
        padding: spacing.medium,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        position: 'relative',
        [`& .${classes.priceContainer}`]: {
            marginBottom: '0px',
        },
    },
    icon: {
        color: `${colors.grey.grey6} !important`,
        marginTop: '4px',
        marginRight: spacing.small,
        '& .material-icons': {
            fontSize: '22px',
        },
    },
    container: {
        display: 'flex',
        marginBottom: '12px',
    },
    variantText: Object.assign(Object.assign(Object.assign({ color: theme.isFlyingFlowers ? colors.black[700] : colors.grey.grey6 }, (theme.isFlyingFlowers ? theme.typography.xxs_bold : theme.typography.small_bold)), theme.typographySpacing.xxs_bold_sm), { lineHeight: theme.isFlyingFlowers ? '1.25rem' : undefined, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg) }),
    topSectionContainer: {
        flexGrow: 1,
    },
    bottomSectionContainer: {},
    textContentSimple: {
        padding: `11px ${spacing.xs}`,
        [`& .${classes.priceContainer}`]: {
            marginBottom: '0px',
        },
        [`& .${classes.productName}`]: Object.assign(Object.assign({}, theme.typography.small_regular), { marginBottom: '0px', color: colors.grey.grey6 }),
        [`& .${classes.price}`]: Object.assign(Object.assign({}, theme.typography.medium_bold), { marginBottom: '0px', color: colors.supplementary.black }),
    },
    deliveryPassImage: {
        width: '100%',
        padding: spacing.medium,
        paddingBottom: 0,
        '& div': {
            height: '108px',
            width: '108px',
        },
        '& img': {
            width: '108px',
        },
    },
    linkWrapper: {
        display: 'flex',
        flexGrow: 1,
        width: '100%',
    },
    iconClass: {
        color: colors.grey.grey6,
    },
    wasPrice: Object.assign(Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.small_bold : undefined)), (theme.isFlyingFlowers ? theme.typographySpacing.small_bold_lg : undefined)), { color: theme.isFlyingFlowers ? colors.wildExotic[400] : undefined, marginBottom: 0 }),
    imageContainer: {
        position: 'relative',
    },
    disableProductCard: {
        [`& img, & .${classes.textContent}, & .${classes.contentWrapperNew}`]: {
            opacity: 0.3,
        },
    },
    productSuggestion: {
        cursor: 'pointer',
    },
    allWasPrice: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg), { color: colors.primary.gold5, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.none) }),
    searchCardWasPrice: Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg),
    strikeThroughPrice: {
        textDecoration: 'line-through',
        color: colors.supplementary.black,
    },
    productCardUKWasPrice: {
        marginBottom: 0,
    },
    freeDelivery: Object.assign(Object.assign(Object.assign({ color: theme.isFlyingFlowers ? colors.black[700] : colors.primary.gold5 }, (theme.isFlyingFlowers ? theme.typography.xxs_bold : theme.typography.small_bold)), theme.typographySpacing.xxs_bold_sm), { lineHeight: theme.isFlyingFlowers ? '1.25rem' : undefined, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_lg) }),
    freeDeliveryMobileStyle: {
        [theme.breakpoints.down('md')]: {
            display: 'block',
            width: '100%',
        },
    },
    trustpilotStars: {
        marginBottom: spacing.medium,
    },
    // New design styles for CRO redesign
    favoriteIconWrapper: {
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        borderRadius: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        padding: '4px',
        flexShrink: 0,
    },
    imageSectionNew: {
        minHeight: '500px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '16px',
    },
    contentSectionNew: {
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        backgroundColor: '#FFFFFF',
    },
    // New design variant styles
    productCardNewDesign: {
        '& .MuiCard-root': {
            backgroundColor: '#FFFFFF',
        },
    },
    productCardNewDesignProductName: Object.assign(Object.assign({}, theme.typography.small_regular), { marginBottom: '10px' }),
    productCardNewDesignPrice: Object.assign(Object.assign({}, theme.typography.small_bold), { paddingRight: 0 }),
    // Now price shown red when there is a was/now discount, per Design Sprint 84
    productCardNewDesignNowPrice: {
        color: theme.statusColors.error.base,
    },
    productCardNewDesignFreeDelivery: {
        fontSize: '16px !important',
        fontWeight: 'bold !important',
        letterSpacing: '0.8px !important',
        lineHeight: '24px !important',
    },
    productCardNewDesignVariantText: Object.assign(Object.assign({}, theme.typography.small_regular), { marginBottom: '0 !important' }),
    // Restructured layout for new design - with secondary badge inside image
    productCardNewDesignLayout: {
        display: 'flex',
        flexDirection: 'column',
        border: 'none !important', // override the border for new design
        boxShadow: 'none !important', //  override the box shadow for new design
        backgroundColor: '#FFFFFF',
    },
    imageContainerNew: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#f5f5f5',
        // single fixed ratio (mobile design height) across all breakpoints so crop stays consistent as the viewport resizes
        aspectRatio: `${MAX_CARD_WIDTH} / 500`,
        // target the main product image explicitly so badge images (e.g. CustomProductBadge) are unaffected
        [`& .${classes.imageNew}`]: {
            objectFit: 'cover',
        },
    },
    imageNew: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
    },
    secondaryBadgeInsideImage: {
        position: 'absolute',
        bottom: spacing.small,
        left: spacing.small,
        right: spacing.small,
        zIndex: 10,
    },
    contentWrapperNew: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    pricePromoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '8px',
        gap: `${spacing.xs}`,
        padding: `${spacing.xs} ${spacing.xs} 0 ${spacing.small}`,
    },
    pricePromoTextWrapper: {
        display: 'flex',
        flexDirection: 'row',
        gap: `${spacing.xs}`,
        alignItems: 'center',
        flex: 1,
    },
    favoriteIconLarge: {
        width: '32px',
        height: '32px',
        flexShrink: 0,
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    productNameNewLayout: {
        marginBottom: '8px !important',
        fontSize: `${spacing.small} !important`, //overriding the product name font size for new design
        lineHeight: '1.4 !important', //overriding the product name line height for new design
    },
    bulletListWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
        padding: `0 ${spacing.small} ${spacing.small} ${spacing.small}`,
    },
    bulletItemNew: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: `${spacing.xs}`,
        fontSize: '14px',
        lineHeight: '1.3',
        marginBottom: 0,
    },
    bulletIconNew: {
        width: '24px',
        height: '24px',
        flexShrink: 0,
        marginTop: '2px',
        color: colors.grey.grey6,
    },
    hamperProductImage: {
        // For hamper products, disable cropping and use standard fit
        objectFit: 'contain',
    },
    skeletonHeightLarge: {
        minHeight: '550px !important', // override the skeletion height for large screens
    },
    productCardNewDesignWasPrice: Object.assign(Object.assign({}, theme.typography.small_bold), { marginBottom: 0 }),
    productCardNewWasPriceContainer: Object.assign(Object.assign({}, theme.typography.small_bold), { marginBottom: 0 }),
    reviewsContainer: {
        padding: `0 ${spacing.small}`,
    },
}));
export default useStyles;
